module.exports = "pegasus/assets/hexline-google.gif";